import { Card, CardBody, Col, Row } from "reactstrap";
import { H3, H5, H6, Image, LI, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../service";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserListTableData } from "../../../data/users/UsersList";
import Breadcrumbs from "../../../common-elements/breadcrumbs/Breadcrumbs";
 
function ViewSalesUserPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const data = UserListTableData.find((user: any) => user.id.toString() === id);
  return (
    <>
      <Breadcrumbs
        mainTitle={t("Profile")}
        parents={[
          { label: t("Users") },
          {
            label: t("Sales"),
            link: `${process.env.PUBLIC_URL}/users/sales`,
          },
        ]}
      />

      <Col md={6}>
        <Card>
          <CardBody>
            <Row className="list-persons" id="addIcon">
              <div className="profile-mail">
                <div className="d-flex">
                  <Image
                    className="img-100 img-fluid m-r-20 rounded-circle update_img_0"
                    src={dynamicImage(data?.image)}
                    alt="users"
                  />

                  <div className="social-details">
                    <H3 className="mb-1 d-flex align-items-center gap-2">
                      {data?.name}
                    </H3>
                    <H5 className="mb-1 d-flex align-items-center gap-2">
                      <i className="fa fa-phone" />
                      <Link to="">{data?.phonenumber}</Link>
                    </H5>
                    <H5 className="mb-1 d-flex align-items-center gap-2">
                      <i className="fa fa-envelope" />
                      <span className="f-light"> {data?.email}</span>
                    </H5>
                  </div>
                  <div
                    className={`badge ${
                      data?.status === "Active" ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {data?.status}
                  </div>
                </div>

                <Row className="list-persons" id="addIcon">
                  <div className="email-general">
                    <H6 className="mb-3">{t("General")}</H6>
                    <UL className="simple-list">
                      <LI>
                        <i className="fa fa-calendar" />
                        {t("BirthDate")}
                        <span className="font-primary email_add_0">
                          {data?.birthDate}
                        </span>
                      </LI>
                      <LI>
                        <i
                          className={`fa fa-${
                            data?.gender?.toLowerCase() === "male"
                              ? "male"
                              : data?.gender?.toLowerCase() === "female"
                              ? "female"
                              : "user"
                          }`}
                        />
                        {t("Gender")}
                        <span className="font-primary email_add_0">
                          {data?.gender}
                        </span>
                      </LI>
                    </UL>
                  </div>
                </Row>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
}

export default ViewSalesUserPage;
